import { Component, Inject, OnInit } from '@angular/core'
import { L10N_LOCALE, L10nLocale } from 'angular-l10n'
import { LocalStorageService } from '../../../services/utils/local-storage.service'
import { DOCUMENT } from '@angular/common'
import { ConfigService } from '../../../services/config.service'

@Component( {
    selector: 'app-error404',
    templateUrl: './error-404.component.html',
    styleUrls: ['../../../app.component.scss', './error-404.component.scss']
} )
export class Error404Component implements OnInit {

    constructor (
        @Inject( L10N_LOCALE ) public locale: L10nLocale,
        @Inject( DOCUMENT ) private document: any,
        private config: ConfigService,
        private localStorage: LocalStorageService
    ) {
    }

    ngOnInit () {
        this.localStorage.checkLanguage()
    }
}
